export default "__VITE_ASSET__Bdpfqyr7__"